module.exports = __webpack_public_path__ + "img/3.fc9ee4cc.svg";